import { DatePicker, Input } from "antd";
import dayjs from "dayjs";
import { Link } from "react-router";
import SimpleTablePage from "../common/SimpleTablePage";
import { date2locale } from "../common/common";
import { api } from "../common/api";
import DebounceSelect from "../common/DebounceSelect";

const renderDate = (date) => (date ? date2locale(date) : "—");
const columns = [
  { title: "ID", key: "id", dataIndex: "id", sorter: true, width: 80 },
  {
    title: "Nominativo (Cognome Nome)",
    key: "name",
    sorter: true,
    dataIndex: "lastName",
    width: 200,
    ellipsis: true,
    render: (name, employee) => (
      <Link to={`${employee.id}`} onClick={(event) => event.stopPropagation()}>
        {employee.lastName} {employee.firstName}
      </Link>
    ),
  },
  {
    title: "Mansione",
    key: "mansion",
    sorter: true,
    dataIndex: ["mansion", "name"],
    width: 240,
    ellipsis: true,
    render: (name) => name ?? "—",
  },
  {
    title: "Codice fiscale",
    key: "fiscalCode",
    dataIndex: "fiscalCode",
    sorter: true,
    width: 190,
    ellipsis: true,
  },
  {
    title: "Badge",
    key: "badgeId",
    dataIndex: "badgeId",
    sorter: true,
    width: 130,
    ellipsis: true,
  },
  {
    title: "ID esterno",
    key: "externalId",
    dataIndex: "externalId",
    sorter: true,
    width: 130,
    ellipsis: true,
  },
  {
    title: "Valido dal",
    key: "validFrom",
    dataIndex: "validFrom",
    sorter: true,
    width: 160,
    render: renderDate,
  },
  {
    title: "Valido al",
    key: "validUntil",
    sorter: true,
    dataIndex: "validUntil",
    width: 160,
    render: renderDate,
  },
];
const dateFilter = (name, label) => ({
  name,
  label,
  readableValue: date2locale,
  formItem: {
    props: {
      getValueProps: (value) => ({ value: value ? dayjs(value) : null }),
      normalize: (value) => value?.format("YYYY-MM-DD"),
    },
    children: <DatePicker format="DD-MM-YYYY" style={{ width: "100%" }} />,
  },
});
const textFilter = (name, label) => ({ name, label, formItem: { children: <Input allowClear /> } });
const filterItems = [
  textFilter("lastName", "Cognome"),
  textFilter("firstName", "Nome"),
  textFilter("fiscalCode", "Codice fiscale"),
  textFilter("badgeId", "Badge"),
  textFilter("externalId", "ID esterno"),
  {
    name: "mansion",
    label: "Mansione",
    readableValue: (value) => value && JSON.parse(value).label,
    formItem: {
      props: {
        getValueProps: (value) => ({ value: value && JSON.parse(value) }),
        normalize: (value) => value && JSON.stringify(value),
      },
      children: (
        <DebounceSelect
          allowClear
          minSize={0}
          fetchOptions={(query) =>
            api.mansion
              .list({ name: query, pageSize: 9999 })
              .then(({ data }) =>
                data.map((mansion) => ({ label: mansion.name, value: mansion.id })),
              )
          }
        />
      ),
    },
  },
  dateFilter("date", "In forza al"),
  dateFilter("startValidFrom", "Inizio validità dal"),
  dateFilter("endValidFrom", "Inizio validità al"),
  dateFilter("startValidUntil", "Fine validità dal"),
  dateFilter("endValidUntil", "Fine validità al"),
];

const fetchEmployees = ({
  query,
  firstName,
  lastName,
  fiscalCode,
  badgeId,
  externalId,
  mansion,
  date,
  startValidFrom,
  endValidFrom,
  startValidUntil,
  endValidUntil,
  sortField,
  sortOrder,
  page,
  pageSize,
}) =>
  api.employee.list({
    query,
    firstName,
    lastName,
    fiscalCode,
    badgeId,
    externalId,
    mansion: mansion ? JSON.parse(mansion).value : undefined,
    date,
    startValidFrom,
    endValidFrom,
    startValidUntil,
    endValidUntil,
    sortField,
    sortOrder,
    page,
    pageSize,
  });

export default function Employees() {
  return (
    <SimpleTablePage
      title="Dipendenti"
      description="Consulta l’elenco dei dipendenti, le mansioni e i periodi di validità"
      resource="employee"
      columns={columns}
      filterItems={filterItems}
      fetchFunction={fetchEmployees}
    />
  );
}
